(function () {
  if (window.__AG_PB_IC_INIT__) return;
  window.__AG_PB_IC_INIT__ = true;

  var PX_PER_SECOND = 48;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getOriginalItems(track) {
    return Array.prototype.slice.call(track.querySelectorAll('[data-ag-ic-item]'));
  }

  function clearClones(track) {
    Array.prototype.slice.call(track.children).forEach(function (child) {
      if (!child.hasAttribute('data-ag-ic-item')) {
        child.remove();
      }
    });
  }

  function measureSetWidth(track, items) {
    if (!items.length) return 0;

    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
    var width = 0;

    items.forEach(function (item, index) {
      width += item.getBoundingClientRect().width;
      if (index < items.length - 1) width += gap;
    });

    /* Include trailing gap so loop seams stay even */
    width += gap;
    return width;
  }

  function buildLoop(root) {
    var track = root.querySelector('.js-ag-pb-ic-track');
    var viewport = root.querySelector('.ag-pb-infinite-carousel__viewport');
    if (!track || !viewport) return;

    clearClones(track);

    var items = getOriginalItems(track);
    if (!items.length) return;

    if (prefersReducedMotion()) {
      root.style.setProperty('--ag-pb-ic-loop-distance', '0px');
      return;
    }

    var viewportW = viewport.getBoundingClientRect().width;
    if (viewportW <= 0) return;

    var setWidth = measureSetWidth(track, items);
    if (setWidth <= 0) return;

    /*
      Seamless loop needs at least one full cloned set after the originals, plus enough to cover the
      viewport while the track shifts by setWidth. A long set (e.g. 7 quotes on mobile) can already be
      wider than 2.2× the viewport, which previously produced zero clones and an empty gap.
    */
    var target = Math.max(viewportW * 2.2, setWidth + viewportW);
    var total = setWidth;
    var guard = 0;

    while (total < target && guard < 40) {
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.removeAttribute('data-ag-ic-item');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      total += setWidth;
      guard++;
    }

    root.style.setProperty('--ag-pb-ic-loop-distance', Math.round(setWidth) + 'px');

    var duration = Math.max(8, setWidth / PX_PER_SECOND);
    root.style.setProperty('--ag-pb-ic-duration', duration.toFixed(2) + 's');
  }

  function initBlock(root) {
    if (root.dataset.agPbIcReady === 'true') return;
    root.dataset.agPbIcReady = 'true';

    function refresh() {
      buildLoop(root);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh).catch(refresh);
    } else {
      refresh();
    }

    requestAnimationFrame(refresh);

    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      /* Mobile browsers fire resize when the URL bar shows/hides; only rebuild on real width changes */
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 150);
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-infinite-carousel').forEach(initBlock);
  }

  function resetAll() {
    document.querySelectorAll('.js-ag-pb-infinite-carousel').forEach(function (root) {
      delete root.dataset.agPbIcReady;
      var track = root.querySelector('.js-ag-pb-ic-track');
      if (track) {
        Array.prototype.slice.call(track.children).forEach(function (child) {
          if (!child.hasAttribute('data-ag-ic-item')) child.remove();
        });
      }
    });
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', resetAll);
  document.addEventListener('shopify:block:select', resetAll);
})();
